import { render, staticRenderFns } from "./QuanLyDonViHanhChinh.vue?vue&type=template&id=c786d35e"
import script from "./QuanLyDonViHanhChinh.vue?vue&type=script&lang=js"
export * from "./QuanLyDonViHanhChinh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports